/**
 * Purpose:
 *   Tailwind CSS class constants for Button component.
 */

export const buttonStyles = {
    base: `
    relative inline-flex select-none items-center justify-center
    font-medium whitespace-nowrap transition-colors outline-none
    disabled:cursor-not-allowed
    focus-visible:outline-2 focus-visible:outline-offset-2
  `,

    sizeSm: `h-8 text-[13px] leading-[20px] gap-1.5 rounded-md`,
    sizeMd: `h-10 text-[14px] leading-[22px] gap-2 rounded-lg`,

    paddingSm: `px-3`,
    paddingMd: `px-4`,

    variants: {
        primary: {
            default: `text-base-white bg-green-400 hover:bg-green-300`,
            disabled: `bg-neutral-200 text-base-white`,
            hoverAppearance: `!bg-green-300`,
        },
        secondary: {
            default: `
        text-neutral-500 bg-base-white border border-neutral-200
        hover:bg-base-0
      `,
            disabled: `text-neutral-300 border border-base-100 bg-base-0`,
            hoverAppearance: `!bg-base-0`,
        },
        danger: {
            default: `
        text-red-600 bg-base-white border border-red-600
        hover:bg-red-0/30
      `,
            disabled: `text-neutral-300 border-base-100 bg-base-0`,
            hoverAppearance: `!bg-red-0/30`,
        },
        tertiary: {
            default: `text-green-400 bg-transparent hover:text-green-200`,
            disabled: `text-neutral-200`,
            hoverAppearance: `!text-green-200`,
        },
    },

    focusVisible: {
        primary: `focus-visible:outline-green-300`,
        secondary: `focus-visible:outline-green-300`,
        danger: `focus-visible:outline-red-300`,
        tertiary: `focus-visible:outline-green-300`,
    },

    /** Same as variant focus-visible ring; for demo state (e.g. Storybook) when forceFocusVisible. ! overrides base outline-none. */
    focusVisibleAppearance: {
        primary: `!outline !outline-2 !outline-offset-2 !outline-green-300`,
        secondary: `!outline !outline-2 !outline-offset-2 !outline-green-300`,
        danger: `!outline !outline-2 !outline-offset-2 !outline-red-300`,
        tertiary: `!outline !outline-2 !outline-offset-2 !outline-green-300`,
    },

    iconOnly: {
        sm: `w-8 h-8 p-0`,
        md: `w-10 h-10 p-0`,
    },

    content: `inline-flex items-center gap-inherit`,
    contentLoading: `opacity-0`,
    contentVisible: `opacity-100`,

    label: `truncate`,

    icon: `inline-flex shrink-0`,
    iconLeading: `mr-2`,
    iconTrailing: `ml-2`,

    spinnerContainer: `absolute inline-flex items-center justify-center`,
};

